import { PageHero } from '@/components/ui/PageHero'
import { herbalWalk } from '@/assets/siteMedia'

export const BooksHero = () => (
  <PageHero
    image={herbalWalk}
    imageAlt="Kandake holding a bunch of fresh herbs in a garden"
    curve={false}
    highlights={['Coming soon', 'Clinical & cultural', 'Written for every woman']}
    title="Knowledge to reclaim"
    accent="your health."
    description={
      <p>
        Knowledge rooted in 20+ years of clinical practice and traditional healing, written to
        empower every woman to understand and reclaim her health.
      </p>
    }
  />
)
